import { Grid } from "@material-ui/core";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";
import Webcam from "react-webcam";
import { useTranslation } from "../../hooks/useTranslation";
import useCamera from "../../hooks/useCamera";
import { useStore } from "../../hooks/useStore";
import SelectCamera from "../common/SelectCamera";
import NotCamera from "../Scan/NotCamera/NotCamera";
import useStyles from "./DialogEditStyles";

type DialogEditProps = {
  image: string;
  title: string;
  open: boolean;
  handleClose: () => void;
  onAccept: (newPhoto: any) => void;
  tabIndex?: number;
  isImage: boolean;
  noEdit?: boolean;
};

const DialogEdit = ({
  image,
  title,
  open,
  handleClose,
  onAccept,
  tabIndex,
  isImage,
  noEdit,
}: DialogEditProps) => {
  const classes = useStyles();
  const webcamRef = React.useRef<Webcam>(null);
  const [takePhoto, setTakePhoto] = useState(false);
  const theme = useTheme();
  const { cameraStore } = useStore();
  const { getListOfCameras } = useCamera();
  const breakpoint = useMediaQuery(theme.breakpoints.down("sm"));
  const { t, BundleKey } = useTranslation();

  const editImage = () => {
    setTakePhoto(true);
  };

  const closeEdit = () => {
    setTakePhoto(false);
    handleClose();
  };

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef?.current?.getScreenshot();
    // La cámara puede no tener aún un frame listo (recién abierta, cambiando de
    // dispositivo); en ese caso getScreenshot() devuelve null y dataURLtoFile
    // explota más abajo, dejando el diálogo colgado sin cerrar.
    if (!imageSrc) return;
    onAccept(imageSrc);
    setTakePhoto(false);
    handleClose();
  }, [webcamRef]);

  useEffect(() => {
    getListOfCameras();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen={breakpoint}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        {title}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={closeEdit}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {!isImage || takePhoto === true ? (
        <>
          <DialogContent>
            <Grid container justifyContent="center" direction="row">
              {cameraStore.empty ? (
                <Grid item>
                  <NotCamera />
                </Grid>
              ) : (
                <>
                  <Grid item>
                    <SelectCamera />
                  </Grid>
                  <Grid item className={classes.center}>
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={{
                        deviceId: cameraStore.deviceId,
                      }}
                      className={classes.video}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            {!cameraStore.empty ? (
              <Button type="submit" color="primary" onClick={capture}>
                {t(BundleKey.DETAIL_SHOWIMAGE_CAPTURE)}
              </Button>
            ) : null}
          </DialogActions>
        </>
      ) : (
        <>
          <DialogContent>
            <Grid container>
              <Grid item>
                <img
                  src={image}
                  alt=""
                  className={classes.editImage}
                  tabIndex={tabIndex}
                />
              </Grid>
            </Grid>
          </DialogContent>
          {noEdit ? null : (
            <DialogActions>
              <Button
                type="submit"
                color="primary"
                autoFocus
                onClick={editImage}
              >
                {t(BundleKey.DETAIL_SHOWIMAGE_EDIT)}
              </Button>
            </DialogActions>
          )}
        </>
      )}
    </Dialog>
  );
};

export default DialogEdit;
